import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const variantStyles = {
  primary: {
    backgroundColor: "#EE295D",
    hoverColor: "#d71d4f",
    textColor: "white",
  },
  secondary: {
    backgroundColor: "transparent",
    hoverColor: "#f5f5f5",
    textColor: "#333",
    border: "1px solid #ccc",
  },
};

const CustomButton = ({
  onClick = () => {},
  variantType = "primary", // primary, secondary
  size = "medium",
  variant = "contained",
  sx = {},
  children,
  isLoading = false,
  ...props
}) => {
  const { backgroundColor, hoverColor, textColor, border } =
    variantStyles[variantType] || variantStyles.primary;

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      sx={{
        backgroundColor,
        color: textColor,
        border: border || "none",
        textTransform: "none",
        "&:hover": {
          backgroundColor: hoverColor,
        },
        ...sx,
      }}
      {...props}
    >
      {isLoading ? (
        <Box display="flex" alignItems="center" gap={1}>
          <CircularProgress size={16} color="inherit" />
          {children}
        </Box>
      ) : (
        children
      )}
    </Button>
  );
};

export default CustomButton;
